import { useInfiniteQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectQueryKeys } from '../constants'

export const myProjectSortOptions = {
  NAME: 'Name',
  CREATED: 'Created',
  LAST_MODIFIED: 'LastModified',
  COMPANY: 'Company',
  ROLE: 'Role',
  OPEN_TASKS: 'OpenTasks',
  OPEN_PINS: 'OpenPins'
}

export const myProjectSortDirectionOptions = {
  ASC: 'ASC',
  DESC: 'DESC'
}

const normalizeMyProjectsQueryArgs = (queryArgs, paramsArg, optionsArg) => {
  if (queryArgs && typeof queryArgs === 'object' && !Array.isArray(queryArgs)) {
    if ('params' in queryArgs || 'options' in queryArgs) {
      return queryArgs
    }

    return {
      params: queryArgs,
      options: paramsArg ?? {}
    }
  }

  return {
    params: paramsArg ?? {},
    options: optionsArg ?? {}
  }
}

export const getMyProjects = async ({ params = {}, pageParam = 0 }) => {
  const {
    search = '',
    projectSort = myProjectSortOptions.NAME,
    sortDirection = myProjectSortDirectionOptions.ASC,
    size = 15
  } = params

  const config = {
    method: 'get',
    params: {
      search,
      projectSort,
      sortDirection,
      page: pageParam,
      size
    }
  }

  const { data } = await api('/api/projects/paged2', config)

  return data.response ?? data
}

export const useGetMyProjectsQuery = (queryArgs, paramsArg, optionsArg) => {
  const { params = {}, options = {} } = normalizeMyProjectsQueryArgs(
    queryArgs,
    paramsArg,
    optionsArg
  )

  const {
    search = '',
    projectSort = myProjectSortOptions.NAME,
    sortDirection = myProjectSortDirectionOptions.ASC,
    page = 0,
    size = 15
  } = params

  const handleQuery = async ({ pageParam = page }) =>
    getMyProjects({
      params: {
        search,
        projectSort,
        sortDirection,
        size
      },
      pageParam
    })

  return useInfiniteQuery({
    queryKey: [
      projectQueryKeys.GET_MY_PROJECTS_QUERY,
      search,
      projectSort,
      sortDirection,
      page,
      size
    ],
    queryFn: handleQuery,
    retry: 0,
    initialPageParam: page,
    getNextPageParam: (lastPage, _pages, lastPageParam) => {
      if (!lastPage || lastPage.last === true) {
        return undefined
      }

      return lastPageParam + 1
    },
    ...options
  })
}
